<ng-container *transloco="let t">
    <div class="blue-background"></div>
    <header
        fxLayout="column"
        focusonnavigation=""
        aria-label="Get started"
        id="homepage-header"
        class="home-header-background"
        tabindex="-1"
    >
        <div
            fxFlexFill
            fxLayout="column"
            fxLayoutAlign="start center"
            class="home-header-section"
        >
            <div class="home-header-headline">
                <h1>{{ client?.clientName }}</h1>
                <h2 *ngIf="client?.isEnabled">{{ introduction }}</h2>
            </div>
            <div
                *ngIf="client?.isEnabled"
                fxFlex="grow"
                fxLayout="row"
                fxLayoutAlign="center center"
                class="home-header-start"
            >
                <button
                    *ngIf="!hasProvider; else applyDirectly"
                    mat-flat-button
                    class="call-to-action-button"
                    (click)="navigateToProgram()"
                >
                    {{ t("home.action") | uppercase }}
                </button>
                <ng-template #applyDirectly>
                    <button
                        mat-flat-button
                        name="Get Started"
                        class="call-to-action-button"
                        (click)="startApplication()"
                        id="get-started-button"
                    >
                        {{ t("home.action") | uppercase }}
                    </button>
                </ng-template>
            </div>
            <div
                *ngIf="!client?.isEnabled"
                fxFlex="grow"
                fxLayout="row"
                fxLayoutAlign="center center"
                class="home-header-disabled"
                [innerHtml]="client?.siteDisabledHtml"
            ></div>
        </div>
    </header>
    <main class="docs-homepage-promo">
        <span class="promo-header">{{
            t("home.step.header", { stepCount: steps.length })
        }}</span>
        <div
            class="docs-homepage-row docs-introduction"
            fxLayout="row wrap"
            fxLayout.sm="column"
            fxLayout.xs="column"
            fxLayoutAlign="center"
            fxFlex.sm="90%"
            fxFlex.xs="90%"
            fxFlexFill
        >
            <div
                *ngFor="let step of steps; let i = index"
                class="docs-homepage-row-column"
            >
                <span class="step-number">{{ i + 1 }}</span>
                <img
                    class="step-icon"
                    [src]="'assets/img/home-icons/' + step.icon"
                    alt="Step {{ i + 1 }}"
                />
                <span class="step-description">{{
                    t(step.descriptionKey)
                }}</span>
            </div>
        </div>
    </main>
</ng-container>
